import { createFileRoute } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { AthleteQuestionnaireSubmissionLayout } from "src/pages/AthleteQuestionnaireSubmissionLayout";
import { createPrivateQuestionnairesRepository } from "src/repositories/questionnaires/createPrivateQuestionnairesRepository";

export const Route = createFileRoute(
  "/_auth/_coach/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/submissions/$submissionId",
)({
  component: RouteComponent,
  ssr: true,
  async loader({ context, params }) {
    return loaderHandler(async () => ({
      data: await context.queryClient.query({
        ...createPrivateQuestionnairesRepository().submissionOptions(
          params.athleteId,
          params.questionnaireId,
          params.submissionId,
        ),
        staleTime: "static",
      }),
    }));
  },
});

function RouteComponent() {
  const { submissionId } = Route.useParams();
  return <AthleteQuestionnaireSubmissionLayout submissionId={submissionId} />;
}
